import FormControl from "./FormControl";
import { IValidator } from "./Validators";

export default class FormGroup extends FormControl<any> implements IValidator {
    private _controls : FormControl<any>[]
    private _ids : Record<string,FormControl<any>> = {}

    constructor(name:string, controls:FormControl<any>[]) {
        super(name, [])
        this._controls = controls
        for(const control of controls) this._ids[control.name] = control
        ;(window as any).g = this
    }

    override get valid(){
        for(const control of this._controls) {
            if (!control.valid) return false
        }
        return true
    }

    control(name:string) { return this._ids[name]}

    markAllAsDirty(){
        for(const control of this._controls){
            if(control instanceof FormGroup) control.markAllAsDirty()
            control.setDirty(true)
        }
        return this.setDirty(true)
    }

    override setDirty(dirty:boolean){
        super.setDirty(dirty)
        var error = this._controls.find(c => !!c.error)
        if (error) this.setError(error.error)
        else this.setError(null)
        return this
    }
}